require("../../css/components/changeLogViewer/changeLogViewer.css");
import _ = require("underscore");
import ko = require("knockout");
import entityMetadata = require("../Atlas/EntityMetadataService");
import moment = require("moment");

export = ChangeLogViewer;
module ChangeLogViewer {
    export interface IChangeLogViewerParams {
        changeLog: IChangeLog;
        entityMetadataResolutionUrl: string;
    }
    interface IMatchingChangeEntity {
        key: string;
        insertValue: IChangeEntity[];
        deleteValue: IChangeEntity[];
    }
    interface IDisplayPrimaryKey extends IPrimaryKey {
        prettyColumnName?: KnockoutObservable<string>;
        prettyKeyValue?: KnockoutObservable<string>;
    }
    interface IDisplayChangeEntityDetail extends IChangeEntityDetail {
        prettyColumnName?: KnockoutObservable<string>;
        prettyOldValue?: KnockoutObservable<string>;
        prettyNewValue?: KnockoutObservable<string>;
    }
    interface IDisplayChangeLog extends IChangeLog {
        changeDateDisplay?: KnockoutComputed<string>;
    }

    export class ChangeLogViewerViewModel {
        changeLog: IChangeLog;
        private metadataService: entityMetadata.Service;
        constructor(params: IChangeLogViewerParams) {
            this.metadataService = new entityMetadata.Service(params.entityMetadataResolutionUrl);
            this.changeLog = params.changeLog;
            if (!this.changeLog.ChangeEntities) {
                this.changeLog.ChangeEntities = [];
            }
            var cl = <IDisplayChangeLog>this.changeLog;
            cl.changeDateDisplay = ko.pureComputed<string>(() => {
                var m = moment.utc(cl.ChangedOnUtc);
                m = m.local();
                return m.format("YYYY-MM-DD hh:mm:ss a");
            });

            this.massageAnswerEntities(this.changeLog);
            var changeEntitiesToRemove: IChangeEntity[] = [];
            ko.utils.arrayForEach(this.changeLog.ChangeEntities, (ce) => {

                if (!ce.PrimaryKeys) {
                    ce.PrimaryKeys = [];
                }
                ko.utils.arrayForEach(ce.PrimaryKeys, (pk) => {
                    var dpk = <IDisplayPrimaryKey>pk;
                    if (!dpk.prettyColumnName) {
                        dpk.prettyColumnName = ko.observable(pk.ColumnName);
                    } if (!dpk.prettyKeyValue) {
                        dpk.prettyKeyValue = ko.observable(pk.KeyValue);
                    }
                });

                if (!ce.Changes) {
                    ce.Changes = [];
                }
                var tp = "default";
                if (ce.ChangeAction === "Insert") {
                    tp = "success";
                } else if (ce.ChangeAction === "Update") {
                    tp = "info";
                } else if (ce.ChangeAction === "Delete") {
                    tp = "danger";
                }
                ce["changeActionBadgeCss"] = "badge badge-" + tp;

                var detailsToRemove: IChangeEntityDetail[] = [];

                ko.utils.arrayForEach(ce.Changes, (cd) => {
                    if (cd.OldValue === undefined) {
                        cd.OldValue = null;
                    }
                    if (cd.NewValue === undefined) {
                        cd.NewValue = null;
                    }


                    // remove change details that aren't really change details
                    if (cd.OldValue === cd.NewValue) {
                        detailsToRemove.push(cd);
                    } else {
                        // remove any change details that are already repeated as key values
                        var pk = ko.utils.arrayFirst(ce.PrimaryKeys, (pk) => { return pk.ColumnName === cd.ColumnName; });
                        if (pk) {
                            detailsToRemove.push(cd);
                        }
                    }

                });
                ko.utils.arrayForEach(detailsToRemove, (dtr) => {
                    ko.utils.arrayRemoveItem(ce.Changes, dtr);
                });


                if (ce.Changes.length === 0) {
                    changeEntitiesToRemove.push(ce);
                }
            });

            this.changeLog.ChangeEntities = _.difference(this.changeLog.ChangeEntities, changeEntitiesToRemove);
            this.processPrettyFields(this.changeLog.ChangeEntities);
        }

        private massageAnswerEntities(cl: IChangeLog) {


            var entries: { [key: string]: IMatchingChangeEntity } = {};

            function getPropertyValue(ce: IChangeEntity, propertyName: string): string {
                var detail = ko.utils.arrayFirst(ce.Changes, (cd) => { return cd.ColumnName === propertyName; });
                if (detail) {
                    if (ce.ChangeAction === "Insert")
                        return detail.NewValue;
                    else if (ce.ChangeAction === "Delete") {
                        return detail.OldValue;
                    }
                }
                return null;
            }

            // match change entities
            ko.utils.arrayForEach(cl.ChangeEntities, (ce) => {

                if (ce.TableName === "Reservation") {
                    ko.utils.arrayForEach(ce.PrimaryKeys, (pk) => {
                        let dpk = <IDisplayPrimaryKey>pk;

                        this.metadataService
                            .lookupFriendlyTitleInformation(
                                new entityMetadata.LookupEntityInfo(pk.ColumnName, pk.KeyValue)).then((result) => {

                                if (result && result.Successful) {
                                    dpk.prettyColumnName(result.FriendlyFieldName);
                                    dpk.prettyKeyValue(result.FriendlyTitle);
                                }
                            });
                    });
                }

                if (ce.TableName === "Answer") {


                    // remove the formResponseId change detail, as it is irrelevant to viewing changes in answers.
                    var formResponseIdChangeDetail = ko.utils.arrayFirst(ce.Changes, (cd) => cd.ColumnName === "FormResponseId");
                    if (formResponseIdChangeDetail) {
                        ko.utils.arrayRemoveItem(ce.Changes, formResponseIdChangeDetail);
                    }

                    var questionId = getPropertyValue(ce, "QuestionId");
                    if (questionId) {
                        var pk = <IDisplayPrimaryKey>{ ColumnName: "QuestionId", KeyValue: questionId, prettyColumnName: ko.observable("QuestionId"), prettyKeyValue: ko.observable(questionId) };
                        ce.PrimaryKeys.push(pk);
                        this.metadataService.lookupFriendlyTitleInformation(new entityMetadata.LookupEntityInfo(pk.ColumnName, pk.KeyValue)).then((result) => {
                            if (result && result.Successful) {
                                pk.prettyColumnName(result.FriendlyFieldName);
                                pk.prettyKeyValue(result.FriendlyTitle);
                            }
                        });

                        var key = questionId;
                        var sequenceNumber = getPropertyValue(ce, "SequenceNumber");
                        if (sequenceNumber) {
                            key = key + "_" + sequenceNumber;
                        }
                        var entry = entries[key];
                        if (!entry) {
                            entry = { key: key, insertValue: null, deleteValue: null };
                            entries[key] = entry;
                        }

                        if (ce.ChangeAction === "Insert") {
                            if (!entry.insertValue) {
                                entry.insertValue = [];
                            }
                            entry.insertValue.push(ce);

                        } else if (ce.ChangeAction === "Delete") {
                            if (!entry.deleteValue) {
                                entry.deleteValue = [];
                            }
                            entry.deleteValue.push(ce);
                        }
                    }
                }
            });


            var newEntries: IChangeEntity[] = [];
            // now loop and combine the matching entities, removing the old values
            _.each(entries, (entry) => {

                var matchValues = (insertValue: IChangeEntity, deleteValue: IChangeEntity) => {
                    var iv = insertValue;
                    var newEntry = <IChangeEntity>{
                        ChangeAction: "Update",
                        TableName: iv.TableName,
                        PrimaryKeys: iv.PrimaryKeys,
                        Changes: iv.Changes
                    };
                    ko.utils.arrayForEach(deleteValue.Changes, (cd) => {
                        var ecd = ko.utils.arrayFirst(newEntry.Changes, (d) => { return d.ColumnName === cd.ColumnName; });
                        if (!ecd) {
                            ecd = <IChangeEntityDetail>{
                                ColumnName: cd.ColumnName,
                                NewValue: null
                            };
                            newEntry.Changes.push(ecd);
                        }
                        ecd.OldValue = cd.OldValue;

                        if ((ecd.OldValue === ecd.NewValue) || ecd.ColumnName === "LastModifiedOn" || ecd.ColumnName === "LastModifiedBy" || ecd.ColumnName === "FormResponseId") {
                            ko.utils.arrayRemoveItem(newEntry.Changes, ecd);
                        }
                    });
                    if (newEntry.Changes.length > 0) {
                        newEntries.push(newEntry);
                    }
                    ko.utils.arrayRemoveItem(cl.ChangeEntities, insertValue);
                    ko.utils.arrayRemoveItem(cl.ChangeEntities, deleteValue);
                }

                var changeDetailsMatch = (insertDetails: IChangeEntityDetail[], deleteDetails: IChangeEntityDetail[]): boolean => {

                    if (insertDetails && deleteDetails) {
                        insertDetails = ko.utils.arrayFilter(insertDetails, (id) => { return id.ColumnName !== "LastModifiedOn" && id.ColumnName !== "LastModifiedBy"; });
                        deleteDetails = ko.utils.arrayFilter(deleteDetails, (id) => { return id.ColumnName !== "LastModifiedOn" && id.ColumnName !== "LastModifiedBy"; });
                        if (insertDetails.length === deleteDetails.length) {
                            var deleteClone = deleteDetails.slice();
                            for (var i = 0; i < insertDetails.length; i += 1) {
                                let id = insertDetails[i];
                                if (id.ColumnName !== "AnswerId") {
                                    let found = false;
                                    for (let j = 0; j < deleteClone.length; j += 1) {
                                        let dd = deleteClone[j];
                                        if (id.ColumnName === dd.ColumnName && id.NewValue === dd.OldValue) {
                                            found = true;
                                            deleteClone.splice(j, 1);
                                            break;
                                        }
                                    }

                                    if (!found) {
                                        return false;
                                    }
                                }
                            }
                            return true;
                        }
                    }
                    return false;
                }

                var shuffleValues = (changeEntity: IMatchingChangeEntity) => {

                    ko.utils.arrayForEach(changeEntity.insertValue, (iv, idx) => {
                        var matchingChange: IChangeEntity = null;
                        var matchingChangeIndex: number = null;
                        for (var j = 0; j < changeEntity.deleteValue.length; j += 1) {
                            if (changeDetailsMatch(iv.Changes, changeEntity.deleteValue[j].Changes)) {
                                matchingChange = changeEntity.deleteValue[j];
                                matchingChangeIndex = j;
                                break;
                            }
                        }
                        if (matchingChange && matchingChangeIndex !== idx) {
                            var swapChange = changeEntity.deleteValue[idx];
                            changeEntity.deleteValue[idx] = matchingChange;
                            changeEntity.deleteValue[matchingChangeIndex] = swapChange;
                        }
                    });
                };
                if (entry.insertValue && entry.deleteValue && entry.insertValue.length === entry.deleteValue.length) {

                    if (entry.insertValue.length > 1) {
                        shuffleValues(entry);
                    }

                    for (var i = 0; i < entry.insertValue.length; i += 1) {
                        matchValues(entry.insertValue[i], entry.deleteValue[i]);
                    }
                }
            });

            cl.ChangeEntities = cl.ChangeEntities.concat(newEntries);
        }

        processPrettyFields(changeEntities: IChangeEntity[]) {
            var reg = /^[a-f0-9]{8}\-[a-f0-9]{4}\-[a-f0-9]{4}\-[a-f0-9]{4}\-[a-f0-9]{12}$/i;
            ko.utils.arrayForEach(changeEntities, (ce) => {
                ko.utils.arrayForEach(ce.Changes, (cd) => {
                    var dcd = <IDisplayChangeEntityDetail>cd;
                    dcd.prettyColumnName = ko.observable<string>(dcd.ColumnName);
                    dcd.prettyOldValue = ko.observable<string>(dcd.OldValue);
                    dcd.prettyNewValue = ko.observable<string>(dcd.NewValue);
                    if (reg.test(cd.OldValue)) {
                        this.metadataService.lookupFriendlyTitleInformation(new entityMetadata.LookupEntityInfo(cd.ColumnName, cd.OldValue)).then((result) => {
                            if (result && result.Successful) {
                                dcd.prettyColumnName(result.FriendlyFieldName);
                                dcd.prettyOldValue(result.FriendlyTitle);
                            }
                        });
                    }
                    if (reg.test(cd.NewValue)) {
                        this.metadataService.lookupFriendlyTitleInformation(new entityMetadata.LookupEntityInfo(cd.ColumnName, cd.NewValue)).then((result) => {
                            if (result && result.Successful) {
                                dcd.prettyColumnName(result.FriendlyFieldName);
                                dcd.prettyNewValue(result.FriendlyTitle);
                            }
                        });
                    }
                });
            });
        }


    }
}